// ── Backend V2 API ──────────────────────────────────────────
const BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:4000";

function getToken() {
  return localStorage.getItem("accessToken") || "";
}

function authHeaders() {
  const token = getToken();
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

// ── Public ──────────────────────────────────────────────────

export async function fetchComments(blogId) {
  const url = blogId
    ? `${BASE}/api/comments?blog_id=${blogId}`
    : `${BASE}/api/comments`;
  const response = await fetch(url);
  if (!response.ok) throw new Error("Failed to fetch comments");
  const data = await response.json();
  return data.comment;
}

export async function insertComment(newComment) {
  const response = await fetch(`${BASE}/api/comments`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(newComment),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || "Failed to insert comment");
  }
  return response.json();
}

// ── Admin (protected) ───────────────────────────────────────

export async function deleteComment(id) {
  const response = await fetch(`${BASE}/api/comments/${id}`, {
    method: "DELETE",
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error("Failed to delete comment");
}
